import { WebParameterContext, WebResponesContext } from '../../model/common';
import { DatePipe} from '@angular/common';
declare var app;
export class ServicesSalesReportDaily {
    constructor() {

    }
    public HandleWebParameterContextBeforeDBRequest(webcontext: WebParameterContext): WebParameterContext {
        // webcontext.ConfigName = '';
        console.log("日报");
        if(webcontext.ConfigName.toLowerCase()=="form"){
            let request = JSON.parse(webcontext.RequestBody);
            request["a_FK_TBProductInformation_ID"]=request.ID;
            request["a_FK_SystemUser_ID"] = webcontext.Account.Id;
            let datepie:DatePipe =new DatePipe("en-US");
            let datetime = datepie.transform(new Date(),"yyyy-MM-dd HH:mm:ss");//上班打卡时间
            request["a_DayDate"] = datetime;
        }
        webcontext.ResponseMessage.Success = false;
        return webcontext;
    }
    public HandleServerContextAfterDBRequest(webParameterContext: WebParameterContext, webContext: WebResponesContext): WebResponesContext {
        return webContext;
    }
}